/**
 * Entity Detail Renderers - Auto-registration
 * 
 * This file automatically registers all entity-specific detail renderers.
 * Import this module at app startup to ensure all renderers are available.
 */

import { registerEntityDetailRenderer } from './entityDetailRendererRegistry';
import { createPersonDetailRenderer } from './person/PersonDetailRenderer';
import { createCatalogDetailRenderer } from './catalog/CatalogDetailRenderer';

// Auto-register all entity-specific renderers
registerEntityDetailRenderer('person', createPersonDetailRenderer);
registerEntityDetailRenderer('catalog', createCatalogDetailRenderer);

// Export registry and types for use elsewhere
export { entityDetailRendererRegistry, registerEntityDetailRenderer } from './entityDetailRendererRegistry';
export { createGenericDetailRenderer } from './generic/GenericDetailRenderer';
export type { EntityDetailContext, EntityDetailRenderer, EntityDetailTab } from './types';
